module.exports = __webpack_public_path__ + "static/1999-281f9622ddb7470d705655d4936931ca.webp";